import {PlainDtoModel} from "../../../../common/entity/dto/plain/plainDto.model";

export class ProviderServiceCoveringModel implements PlainDtoModel {
    id: number;
    name: string;
    code: string;
    active: boolean;
}
